import React from "react";
import { Link } from "react-router-dom";
import videoBg from "../assets/video.mp4";
import { ArrowRight } from "lucide-react";

const VideoSection = () => (
  <section className="relative h-screen flex flex-col items-center justify-center bg-black overflow-hidden">
    {/* Video Background */}
    <video
      id="video-section"
      className="absolute inset-0 w-full h-full object-cover opacity-70 z-0"
      src={videoBg}
      autoPlay
      loop
      muted
      playsInline
    />

    {/* Dark Gradient Overlay for optimal contrast and text readability */}
    <div className="absolute inset-0 z-[1] bg-gradient-to-b from-black/70 via-black/50 to-black/80 pointer-events-none" />

    {/* Hero text overlay */}
    <div className="relative z-10 flex flex-col items-center text-center px-6 max-w-4xl mx-auto mt-12">
      {/* <p className="text-amber-400 font-medium text-xs sm:text-sm tracking-[0.35em] uppercase mb-4 drop-shadow-md">
        Arch Point Consultants
      </p>
       */}
      {/* <h1 className="text-white font-extrabold text-3xl sm:text-5xl md:text-6xl tracking-tight leading-tight mb-6 drop-shadow-lg">
        Shape Spaces,{" "}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">
          Shape Experiences
        </span>
      </h1>

      <p className="text-gray-200 text-sm sm:text-lg max-w-2xl mb-8 font-light leading-relaxed drop-shadow">
        An architecture and interior design studio crafting spaces across Jaipur and beyond where every detail is considered, from concept to completion.
      </p> */}

      {/* Action Buttons */}
      {/* <div className="flex flex-col sm:flex-row items-center gap-4">
        <Link
          to="/architectural-design"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-7 py-3.5 rounded-xl font-semibold text-sm hover:from-amber-600 hover:to-orange-600 shadow-lg shadow-orange-500/20 transition-all duration-300"
        >
          Explore Our Work
          <ArrowRight size={18} />
        </Link>
      </div> */}
    </div>
  </section>
);

export default VideoSection;